import request from '@/utils/request'
const apiPath = '/course/courseScenarioExercise'
const courseScenarioExerciseApi = {
  /**
   * 新增【情景练习】
   */
  create(data) {
    return request.post(apiPath, data)
  },
  /**
   * 修改【情景练习】
   */
  update(data) {
    return request.put(apiPath, data)
  },
  /**
   * 分页查询【情景练习】
   */
  fetchList(query) {
    return request.get(apiPath, { params: query })
  },
  /**
   * 查看【情景练习】详情
   */
  fetchById(id) {
    return request.get(`${apiPath}/${id}`)
  },
  /**
   * 删除单个【情景练习】
   */
  deleteById(id) {
    return request.delete(`${apiPath}/${id}`)
  },
  setIsEnable(data) {
    return request.post(apiPath + '/batchState', data, { isFormData: 1 })
  },
}
export default courseScenarioExerciseApi
